import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Select } from "shared/ui/input/select/select/Select"

import { useFloorFormContext } from "../../contexts/FloorFormContext"

export type FloorPositionInputProps = WithClassName

export const FloorPositionInput = React.memo(
  ({ className }: FloorPositionInputProps) => {
    const { t } = useTranslation()
    const {
      isReadonly,
      isDisabled,
      positionOptions,
      isLoadingPositionOptions,
      hidePosition
    } = useFloorFormContext()

    if (hidePosition || isReadonly) {
      return null
    }

    return (
      <Select.Root
        name="displayPosition"
        label={t("ProjectChild.Position")}
        className={classNames("floor-form__position", className)}
        readonly={isReadonly}
        disabled={isDisabled}
        loading={isLoadingPositionOptions}
      >
        <Select.Label />
        <Select.Input options={positionOptions} />
        <Select.ErrorMessage />
      </Select.Root>
    )
  }
)
